const sliderLandingData = [
    {
        id:"1",
        image:require("../../assets/image/01.jpg")
    },
    {
        id:"2",
        image:require("../../assets/image/01.jpg")
    },
    {
        id:"3",
        image:require("../../assets/image/01.jpg")
    },
]

export default sliderLandingData;